import { getComponentJson } from "common/utils/serverRequest";
export const getOfficeAccountManager = (dispatch, officeId) => {
    return getComponentJson(dispatch, `/api/contact-us/office-account-holder?officeId=${officeId}`).then((response) => response.json()).then(json => json, err => err);
};
